import './index.scss'
import LogoS from '../../../assets/images/profile-pic.png'

const Logo = () => {
  return (
    <div className="pic-container">
      <img className="propic" src={LogoS} alt="Saerom's Pic" />
    </div>
  )
}

export default Logo
